import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Component, Input, OnInit } from '@angular/core';
import { MainMenuComponent } from '../main-menu/main-menu.component';
import { SidebarModule } from 'primeng/sidebar';
import { NgIf } from '@angular/common';

@Component({
  selector: 'app-navbar',
  standalone: true,
  templateUrl: './navbar.component.html',
  providers: [DialogService],
  imports: [SidebarModule, NgIf]
})
export class NavbarComponent implements OnInit {

  @Input()
  public showLogo: boolean = true;

  ref: DynamicDialogRef | undefined;

  constructor(public dialogService: DialogService) {
  }

  ngOnInit(): void {
  }

  public showMenu() {
    this.ref = this.dialogService.open(MainMenuComponent, {
      position: 'top',
      dismissableMask: true,
      closable: false,
      styleClass: 'bg-transparent shadow-none modal-w-full'
    });

    this.ref.onClose.subscribe(() => {
      const overlayElement = document.querySelector('.p-dialog-mask');

      if (overlayElement) {
        overlayElement?.parentNode?.removeChild(overlayElement);
      }
    });
  }
}
